export const SIDEBAR_TICKET_ID_KEY = "sidebarTicketId" as const;
